module.exports = __webpack_public_path__ + "img/头部@2x.c7c3b08b.png";